<template>
 <div>
     <div class="row justify-content-center ">
         <div class="col-md-12">
             <div class="col-md-12 mb-2">
                <p>ADD ANY OTHER INFORMATION IN THE SPACE BELOW</p>
             </div>
             <div class="form-group col-md-12">
                 <div class="sb-list-fitem-regular">
                     Notes
                 </div>
                 <textarea type="text" placeholder="Note" v-model="user_note" id="note" name="note" class="required form-control"></textarea>
                 <div class="text-right mt-3">
                     <a href="#" @click.prevent="saveNote" class="btn btn-success">Save</a>
                 </div>
             </div>

         </div>
     </div>
 </div>
</template>

<script>
    export default {
        props:['note'],
        mounted() {

        },
        data(){
            return {
                route: '/api/user-note',
                user_note:this.note
            }
        },
        methods:{
            log(s){
                console.log(s)
            },
            saveNote(){
                this.$http.post(this.route, {note:this.user_note})
                    .then(function(response) {
                        this.$notify({
                            type:'success',
                            title: 'Success',
                            text: 'Note was recorded!'
                        });
                    }, (response) => {
                        this._handleErrors(response.data, '#note-form')
                    })
            },
            _handleErrors: function(items, selector)
            {
                $('.has-error').removeClass('has-error')
                $('.help-block').remove()

                for (var error in items['errors']) {
                    if (items['errors'].hasOwnProperty(error)) {
                        var text = error;
                        var parts = text.split('.');
                        var name = parts.pop();
                        var el = $(selector + ' [name="'+name+'"]')
                        el.closest('.form-group').addClass('has-error')
                        $( '<p class="help-block">'+(items['errors'][error].join(', '))+'</p>' ).insertAfter(selector + ' [name="'+name+'"]');
                    }
                }
            }
        }

    }
</script>
